<!-- PATCHED WEB VERSION - spot-chart-card.component.html -->
<!-- Adds timeframe selector dropdown -->

<mat-card class="chart-card">
  <mat-card-title>
    <div class="header-wrapper">
      <div class="title-text">
        <span>Chart</span>
        <span class="mode-pill" [class.fallback]="chartMode === 'fallback'">
          {{ chartStatus }}
        </span>
        <span class="symbol-pill" *ngIf="advancedSymbol">{{ advancedSymbol }}</span>
      </div>

      <div class="controls">
        <button
          class="fallback-button"
          *ngIf="chartMode === 'fallback'"
          type="button"
          (click)="reloadAdvancedChart()"
        >
          Advanced
        </button>
        <select
          class="tf-select"
          [value]="timeframeSec"
          (change)="setTimeframe($any($event.target).value)"
        >
          <option value="5">5s</option>
          <option value="60">1m</option>
          <option value="300">5m</option>
          <option value="900">15m</option>
          <option value="3600">1h</option>
          <option value="21600">6h</option>
          <option value="86400">1d</option>
        </select>
      </div>
    </div>
  </mat-card-title>

  <mat-card-content>
    <div #chart class="chart-container"></div>
  </mat-card-content>
</mat-card>
